import { render, staticRenderFns } from "./Roof.vue?vue&type=template&id=6d717aa0&"
import script from "./Roof.vue?vue&type=script&lang=js&"
export * from "./Roof.vue?vue&type=script&lang=js&"
import style0 from "./Roof.vue?vue&type=style&index=0&id=6d717aa0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports